import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingIndicatorComponent } from '../../../loading-indicator/loading-indicator.component';
import { LoadingIndicatorPanelComponent } from '../../../loading-indicator/loading-indicator-panel.component';

@Component({
    selector: 'td-wb-table-loading',
    templateUrl: 'table-loading.component.html',
    styleUrls: ['table-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingIndicatorPanelComponent, LoadingIndicatorComponent]
})
export class TableLoadingComponent {
}
